import { ageLimitOrganizer } from "./organiser.utils";
import { isValidDate } from "./travel-date.utils";

export function getDobValidation(
  age: string,
  dateValue: string,
  dobMinLimit: string,
  invalidAge: string,
  dobMaxAge: string
) {
  let errorMessage = "";
  if (!isValidDate(dateValue as unknown as Date)) {
    errorMessage = "Invalid Date of Birth";
  }
  if (age) {
    if (Number(age) < 0 || Number(age) === -0.5) {
      errorMessage = invalidAge;
    } else if (Number(age) > ageLimitOrganizer.max) {
      errorMessage = dobMaxAge;
    } else if (Number(age) < ageLimitOrganizer.min) {
      errorMessage = dobMinLimit;
    }
  }
  return errorMessage;
}

export function getDobValidationState(dateValue: string, age: string): boolean {
  if (!dateValue || !isValidDate(dateValue as unknown as Date)) return false;

  const numericAge = Number(age);
  if (Number.isNaN(numericAge)) return false;

  return (
    numericAge < 0 ||
    numericAge < ageLimitOrganizer.min ||
    numericAge > ageLimitOrganizer.max
  );
}
